import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AppCommonModule } from '../common.module';
import { ModalShellComponent } from '../ui/modal-shell/modal-shell.component';
import { AllocationWorkspaceShiftEditContext } from './allocation-workspace.service';
import { ScheduleComponent } from './schedule.component';

@Component({
  selector: 'app-allocation-workspace-dialog',
  templateUrl: './allocation-workspace.dialog.html',
  styleUrls: ['./allocation-workspace.dialog.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AppCommonModule,
    ModalShellComponent,
    ScheduleComponent,
  ],
})
export class AllocationWorkspaceDialogComponent {
  private modalCtrl = inject(ModalController);

  initialDate = input<Date | null>(null);
  initialUserGuid = input<string | null>(null);
  shiftEditContext = input<AllocationWorkspaceShiftEditContext | null>(null);

  dismiss() {
    this.modalCtrl.dismiss();
  }
}
